export const selectFromMetadata = new Map([
  ['Contracts', 'Description,Status,AddedOn,SignedOn,ContractId'],
  ['Persons', 'FullName,LegalBusinessName,TradeName,PersonId'],
  [
    'Pessoas',
    'PessoaCd,NomeCompleto,Consultores,Aniversario,VrAbertoAtual,DataProximoVencimento,NumerosTelefones,Assinaturas,AssinaturasHorarios,Situacao,PessoaId',
  ],
  ['Schedules', 'AutomationDescription,CustomerName,ConsultantName,Type,Status,ScheduledFor,ScheduleId'],
  ['Automations', 'Type,Name,Body,IsActive,AutomationId'],
]);

export const predefinedFilter = new Map([['User', '']]);
